<template>
  <li class="videoCard">
      <div class="cardBox">
          <video v-if="isplay" :id="video.ID" :src="video.VideoUrl"  class="cardCover"/>
          <div v-if="!isplay" class="mask">
              <img src="/images/play.png" class="play" v-on:click="play(video.ID)">
          </div>
          <img v-if="!isplay" :src="video.ImageUrl" class="cardCover">
          <span class="title">{{video.Content}}</span>
      </div>
  </li>
</template>
<script>
export default {
  name: "videobox",
  //data:{},
  props: ["video"],
  data(){
    return {isplay:false}
  },
  methods: {
      play:function(videoID){
        var t=this;
        t.isplay=true;
        t.$nextTick(function(){
            var video=document.getElementById(videoID);
            if(video.paused){ //如果已暂停则播放
              video.play(); //播放控制
            }else{ // 已播放点击则暂停
              video.pause(); //暂停控制
            }
            video.onended = function() {
                t.isplay=false;
            };
        })
      }
  },
  mounted() {
  }
};
</script>

<style scoped>
.videoCard{
    width: 240px;
    height: 400px;
    margin-top: 30px;
    margin-left: 20px;
    display: inline-block;
    vertical-align: top;
  }
  .videoCard .cardBox{
    box-sizing: border-box;
    padding: 0px;
    border-radius: 4px;
    background-color: #fff;
    -webkit-transform: translateZ(0px);
    position: relative;
  }
  .cardBox .cardCover{
    width: 100%;
    height: 360px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .cardBox .mask{
    width: 100%;
    height: 360px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: rgba(0,0,0,0.3);
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cardBox .mask .play{
     width: 24px;
     height: 24px;
     cursor: pointer;
  }
   .cardBox .title{
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 500;
    padding: 10px;
    overflow: hidden;
  }
</style>
